import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {authService} from "../../../../../client/connection/Services";
import {collapseIframe, collapseIframeAndExpandWallet} from "../../../../widget/misc/WidgetUtils";
import {MerchantButton} from "../../../../common/MerchantButton";
import {HappyFaceIcon} from "../../../../../core/ui/SVGElements.jsx";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {Perk} from "./components/CoverageDescriptionElements";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {Controller} from "../../../Controller";
import {iFrameState} from "../../../../services/IFrameState";
import {iFrameConnection} from "../../../../services/IFrameConnection.js";
import {IFrameMessages} from "../../../../../blink-sdk/messaging/IFrameMessages.js";


export class SubscribeThankYouPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: "center",
        ...this.themeProps.MERCHANT_TITLE_STYLE,
    };

    @styleRule
    icon = {
        textAlign: "center",
    };

    @styleRule
    message = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(SubscribeThankYouPanelStyle)
export class SubscribeThankYouPanel extends BasePanelPage {
    getGuidelines() {
        if (iFrameState.forceHideWallet) {
            return []
        }

        return [
            <Perk text={Messages.subscribeThankYouGuideline1}/>,
            <Perk text={Messages.subscribeThankYouGuideline2}/>,
        ]
    }

    render() {
        const {styleSheet} = this;
        const offer = Controller.subscriptionPlan.selectedOffer;
        let textElements;

        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            textElements = [
                <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                    {Messages.subscribeThankYouTitle}
                </div>,
                <MessageElement className={styleSheet.message} message={Messages.subscribeThankYouText(offer.coverage.name)}/>,
                <div className={styleSheet.message}>{Messages.tnrSubscribeSuccess}</div>,
                <MessageElement className={styleSheet.message}
                                message={Messages.subscribeAndEditSuccess(iFrameMerchantService.getMerchant().getName())} />
            ];
        } else {
            textElements = [
                <HappyFaceIcon className={styleSheet.icon}/>,
                <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                    {Messages.subscribeThankYouTitle}
                </div>,
                <div className={styleSheet.message}>{Messages.subscribeThankYouText(offer.coverage.name)}</div>,
            ]
        }

        const onOK = () => {
            const {iframeParams} = iFrameState;
            const merchant = iFrameMerchantService.getMerchant();

            const urlToRedirect = iframeParams.urlToRedirectOnSuccess || (iframeParams.inlineFlow && merchant.url);
            if (urlToRedirect) {
                iFrameConnection.sendToSDK(IFrameMessages.REDIRECT_TO_URL, {url: urlToRedirect});
            } else {
                collapseIframe();
            }
        }

        return [
            textElements,
            this.getGuidelines(),
            <MerchantButton onClick={onOK} className={styleSheet.actionButton}>
                {Messages.ok}
            </MerchantButton>,
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null :
                <div className={styleSheet.backButton} onClick={collapseIframeAndExpandWallet}>
                    {Messages.manageMyAccount}
                </div>
        ];
    }

    onMount() {
        super.onMount();

        authService.onAuthenticationChange(() => {
            if (!authService.isAuthenticated()) {
                collapseIframe();
            }
        });
    }
}
